import { render, staticRenderFns } from "./SalesPriceList.vue?vue&type=template&id=1ca6d36b&scoped=true"
import script from "./SalesPriceList.vue?vue&type=script&lang=js"
export * from "./SalesPriceList.vue?vue&type=script&lang=js"
import style0 from "./SalesPriceList.vue?vue&type=style&index=0&id=1ca6d36b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca6d36b",
  null
  
)

export default component.exports